'use client';
import ArrowButtonSvg from '@/assets/icons/arrow-button.svg?react';
import { borderRadiusShorthand, useLayoutStyle } from "@/lib/providers/layout-style-provider";
import { ProductHighlight } from '@/util/query/product-highlight-query';
import { MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import { CUSTOMER_LEVEL } from "@prisma/client";
import ProductHighlightCarousel from './product-highlight-carousel';

type ProductHighlightType1Props = {
    data: ProductHighlight;
    productList: MSProductWithFullDetailWithVaraintPreset[];
    level: CUSTOMER_LEVEL;
    shopCurrency: string;
    /** Number of GRADIENT cards shown per row on mobile. Defaults to 3. */
    mobileColumn?: number;
}

const ProductHighlightType1 = (props: ProductHighlightType1Props) => {
    const { data, productList, level, shopCurrency, mobileColumn } = props;
    const layoutStyle = useLayoutStyle();

    return ((data.attributes && (data.attributes.title || data.attributes.description || data.attributes.buttonDisplayName)) || (productList.length > 0)) && (
        <div id={`product-highlight-component-type1-container-${data.id}`} 
            className={mobileColumn === 3 ? 'w-full py-[24px] px-[18px] sm:px-[120px]':'w-full py-[40px] px-[30px] sm:px-[120px]'}
        >
            <div id="product-highlight-component-type1-content" className={`w-full flex flex-col justify-center items-center ${mobileColumn === 3?'gap-6':'gap-10'}`}>
                {(data.attributes && (data.attributes.title || data.attributes.description || data.attributes.buttonDisplayName)) && 
                    <div id="product-highlight-component-type1-info" className="w-full flex flex-row justify-between items-end sm:items-center gap-4">
                        {(data.attributes.title || data.attributes.description) && 
                            (<div id="product-highlight-component-type1-title-container" className="w-full flex flex-col gap-2 items-start text-left">
                                {data.attributes.title && 
                                    <h2 
                                        id="product-highlight-component-type1-title" 
                                    className={`lg:text-[2.5rem] text-[1.5rem]`}
                                        style={{ color: "#54301A"}}
                                    >
                                        {data.attributes.title}
                                    </h2>
                                }
                                {data.attributes.description && 
                                    <p
                                        id="product-highlight-component-type1-description" 
                                        className={`sm:text-base font-normal ${mobileColumn === 3 ? 'text-sm':'text-base'}`}
                                        style={{ color: "#54301A"}}
                                    >
                                        {data.attributes.description}
                                    </p>}
                            </div>)}
                        {data.attributes.buttonDisplayName && 
                        <a id="product-highlight-component-type1-button-link" href={data.attributes.buttonLinkUrl || ""} aria-label="button">
                            <button 
                                id="product-highlight-component-type1-button" 
                                aria-label="Link Button"
                                className="min-w-[120px] min-h-[38px] sm:min-w-[221px] sm:min-h-[60px] w-fit h-fit py-[8px] pl-[20px] pr-[4px] sm:py-[8px] sm:pl-[40px] sm:pr-[8px] font-medium border-solid border-2 dynamic-bg dynamic-color dynamic-border"
                                
                                style={
                                    {
                                        "--dynamic-bg": "#FFC20E",
                                        "--dynamic-hover-bg": "#FFF200",
                                        "--dynamic-color": "#54301A",
                                        "--dynamic-hover-color": "#54301A",
                                        "--dynamic-focus-color": "#54301A",
                                        "--dynamic-hover-focus-color": "#54301A",
                                        "--dynamic-border": "#FFFFFF",
                                        "--dynamic-hover-border": "#FFFFFF",
                                        borderRadius: borderRadiusShorthand(layoutStyle)
                                    } as React.CSSProperties
                                }>
                                <div id="product-highlight-component-type1-button-content" className={`flex flex-row gap-2 items-center justify-between sm:text-base whitespace-nowrap font-medium ${mobileColumn === 3 ? 'text-[10px]':'text-sm'}`}>
                                    {data.attributes.buttonDisplayName}
                                    <ArrowButtonSvg id="product-highlight-component-type1-button-arrow" className={`h-6 w-6 sm:w-10 sm:h-10`}/>
                                </div>
                            </button>
                        </a>}
                    </div>
                }
                {(productList.length > 0) && (
                    <ProductHighlightCarousel
                        productList={productList}
                        level={level}
                        shopCurrency={shopCurrency}
                        type="TYPE_1"
                        mobileColumn={mobileColumn}
                    />
                )}
            </div>
        </div>
    )
}

export default ProductHighlightType1